export default __webpack_public_path__ + "static/media/gallery_04.f2cdf7b8.jpg";